import { useTranslation } from 'react-i18next';
import { Sparkles } from 'lucide-react';

/** Quick-action chips shown on a new discussion. */
const TOPICS = ['validateStrategy', 'improveMarketing', 'buildPitchDeck'] as const;

/**
 * Quick-action chips under the Discussion Room composer: tapping one sends a
 * starter message about that topic, so a founder can kick off a discussion
 * without typing. Shown only on the empty-state (no messages yet).
 */
export function DiscussionQuickActions({
  onPick,
  disabled = false,
}: {
  /** Send the topic's starter prompt. */
  onPick: (prompt: string) => void;
  disabled?: boolean;
}): JSX.Element {
  const { t } = useTranslation();

  return (
    <div
      className="mt-3 flex flex-wrap items-center justify-center gap-2"
      data-testid="discussion-quick-actions"
    >
      {TOPICS.map((topic) => (
        <button
          key={topic}
          type="button"
          disabled={disabled}
          onClick={() => onPick(t(`discussions.quickActions.${topic}.prompt`))}
          data-testid={`discussion-quick-action-${topic}`}
          className="inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-white px-3 py-1.5 text-sm text-gray-700 transition-colors hover:border-primary-300 hover:bg-primary-50 disabled:opacity-50 dark:border-gray-700 dark:bg-gray-900 dark:text-gray-200 dark:hover:bg-gray-800"
        >
          <Sparkles size={14} className="text-primary-500" />
          {t(`discussions.quickActions.${topic}.label`)}
        </button>
      ))}
    </div>
  );
}

export default DiscussionQuickActions;
